import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { JourneyAssistDialog } from './JourneyAssistDialog';
import { PROMPT_DEFAULT } from './JourneyAssist.constants';

const schema = z.object({
  prompt: z.string(),
});

export const JourneyAssistFormProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const methods = useForm<any>({
    defaultValues: {
      prompt: PROMPT_DEFAULT,
    },
    mode: 'onChange',
    resolver: zodResolver(schema),
  });
  return <FormProvider {...methods}>{children}</FormProvider>;
};

export const JourneyAssist = (props: any) => {
  return (
    <JourneyAssistFormProvider>
      <JourneyAssistDialog {...props} />
    </JourneyAssistFormProvider>
  );
};
